const state = {};

const getters = {};

const actions = {

	LoadBackupRepos({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backup.get_repos');
			this._vm.$axios.get(r)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;
						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetRepoDetails({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.get_repo_details', {
				repo_id: request_data['repo_id'],
			});

			this._vm.$axios.get(r)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;

						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	SaveRepoData({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.save_repo_data', {
				repo_id: request_data['repo_id'],
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	DeleteRepo({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.delete_repo', {
				repo_id: request_data['repo_id']
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetBackupJobs({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backup.get-backup-jobs', {
				domain_id: request_data.domain_id,
			});

			this._vm.$axios.get(r)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;
						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetBackupJobDetails({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backup.get-backup-job-details', {
				domain_id: request_data['domain_id'],
				backup_job_id: request_data['backup_job_id'],
			});

			this._vm.$axios.get(r)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;
						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	GetBackupJobDefaults({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backup.get-backup-job-defaults', {
				domain_id: request_data['domain_id'],
			});

			this._vm.$axios.get(r)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;
						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	SaveBackupJob({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backup.save_backup_job', {
				domain_id: request_data.domain_id,
				backup_job_id: request_data.backup_job_id,
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;
						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	DeleteBackupJob({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.delete-job', {
				domain_id: request_data['domain_id'],
				backup_job_id: request_data['backup_job_id']
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	//------------------------------------------------------------------------------------------------------//

	LoadBackups({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('get_backups', {
				domain_id: request_data['domain_id'],
			});

			this._vm.$axios.get(r)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						let data = response.data;
						resolve(data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	DeleteBackupJobRun({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.delete_job_run', {
				domain_id: request_data['domain_id'],
				job_run_id: request_data['job_run_id']
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	AddBackupJob({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.add_backup_job', {
				domain_id: request_data['backup_job_data']['domain_id'],
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},

	RunNowJob({commit}, request_data)
	{
		return new Promise((resolve, reject) => {
			let r = this._vm.$laroute.route('backups.jobs.run_now', {
				domain_id: request_data['domain_id'],
				job_id: request_data['job_id']
			});

			this._vm.$axios.post(r, request_data)
				.then(response => {
					if (response.data.call_status === "OK")
					{
						resolve(response.data);
					}
					else
					{
						reject(response.data.error);
					}
				})
				.catch(error => {
					reject(error);
				})
				.finally(() => {

				});
		});
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
